<template>
  <div>
    <dropdown-menu
      id="drop-dot"
      v-model="show"
      :right="true"
      :hover="true"
      :hover_time="hoverTime"
      transition="translate-fade-down"
      v-if="(showEditMenu || showDeleteRequest) && getItemAvailability(item)"
    >
      <md-button
        :md-ripple="false"
        md-elevation="0"
        class="md-icon-button dropdown-toggle menu-dot"
        :class="[{ 'dropdown-menu-right' : isMenuRight}]"
        :data-cy="`dotItemMenu-${item.title}`"
      >
        <md-icon class="md-size-2x vert-color">more_vert</md-icon>
      </md-button>
      <div slot="dropdown" class="dot-drop">
        <router-link
          class="dropdown-item"
          :to="`/s-app/item-review?edit=true&item_id=${itemId}`"
          v-if="showEditMenu"
        >
          <md-icon id="edit-icon">edit</md-icon>
          <span>Edit</span>
          <md-tooltip md-direction="right" class="s-tooltip tp-chat-position"
            >Edit item</md-tooltip
          >
        </router-link>
        <a
          class="dropdown-item"
          href="#"
          v-if="showDeleteRequest"
          @click.prevent="$emit('delete-item')"
          :data-cy="`deleteItemButton-${item.title}`"
        >
          <md-icon id="delete-icon">delete</md-icon>
          <span class="delete-button">Delete</span>
          <md-tooltip md-direction="right" class="s-tooltip tp-chat-position"
            >Delete item</md-tooltip
          >
        </a>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from "@innologica/vue-dropdown-menu";
import ItemHelper from "@/mixins/ItemHelper";

export default {
  name: "DotMenu",
  props: ["showEditMenu", "itemId", "showDeleteRequest", "item", "isMenuRight"],
  mixins: [ItemHelper],
  components: {
    DropdownMenu
  },
  data() {
    return {
      show: false,
      hoverTime: 2
    };
  }
};
</script>

<style lang="scss" scoped>
#drop-dot .show {
  width: 245px !important;
}
#drop-dot a {
  color: $black !important;
}
#drop-dot span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}
#drop-dot a:active {
  background-color: transparent;
}
#edit-icon,
#delete-icon {
  margin-top: -2px;
  margin-right: 0.4em;
}
.vert-color,
#edit-icon {
  color: $black !important;
}
#delete-icon,
.delete-button {
  color: $danger;
}
.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
.edit-color {
  color: $black !important;
}
.delete-color {
  color: $danger !important;
}
.dropdown-menu-right {
  right: 0;
}
</style>

<style lang="scss" scoped>
#drop-dot .md-button:not([disabled]):hover:before {
  background-color: unset !important;
}
</style>
